<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g transform="translate(-703 -1227)">
      <circle class="settings-a" cx="3" cy="3" r="3" transform="translate(711 1235)"/>
      <path class="settings-a"
            d="M17.727,13.727a1.5,1.5,0,0,0,.3,1.655l.055.055a1.819,1.819,0,1,1-2.573,2.573l-.055-.055a1.512,1.512,0,0,0-2.564,1.073v.155a1.818,1.818,0,0,1-3.636,0V19.1a1.5,1.5,0,0,0-.982-1.373,1.5,1.5,0,0,0-1.655.3l-.055.055a1.819,1.819,0,1,1-2.573-2.573l.055-.055a1.512,1.512,0,0,0-1.073-2.564H2.818a1.818,1.818,0,0,1,0-3.636H2.9a1.5,1.5,0,0,0,1.373-.982,1.5,1.5,0,0,0-.3-1.655l-.055-.055A1.819,1.819,0,1,1,6.491,3.991l.055.055a1.5,1.5,0,0,0,1.655.3h.073a1.5,1.5,0,0,0,.909-1.373V2.818a1.818,1.818,0,0,1,3.636,0V2.9a1.512,1.512,0,0,0,2.564,1.073l.055-.055a1.819,1.819,0,1,1,2.573,2.573l-.055.055a1.5,1.5,0,0,0-.3,1.655v.073a1.5,1.5,0,0,0,1.373.909h.155a1.818,1.818,0,0,1,0,3.636H19.1A1.5,1.5,0,0,0,17.727,13.727Z"
            transform="translate(703 1227)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SettingsIcon'
}
</script>

<style scoped>
svg .settings-a {
  fill: none;
  stroke: #FFFFFF;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
